/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Invite_Error1Inputs */

const en_usermanagement_invite_error1 = /** @type {(inputs: Usermanagement_Invite_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't send invitation`)
};

/**
* | output |
* | --- |
* | "Couldn't send invitation" |
*
* @param {Usermanagement_Invite_Error1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_invite_error1 = /** @type {((inputs?: Usermanagement_Invite_Error1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Invite_Error1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_invite_error1(inputs)
});
export { usermanagement_invite_error1 as "userManagement_invite_error" }